export const KPI_FIELDS = [
  { key: "mandats",   label: "Mandats rentrés",   unit: "",  obj: 8 },
  { key: "exclusifs", label: "dont Exclusifs",     unit: "",  obj: 5 },
  { key: "visites",   label: "Visites réalisées",  unit: "",  obj: 15 },
  { key: "offres",    label: "Offres reçues",      unit: "",  obj: 4 },
  { key: "compromis", label: "Compromis signés",   unit: "",  obj: 2 },
  { key: "actes",     label: "Actes authentiques", unit: "",  obj: 2 },
  { key: "ca",        label: "CA HT (€)",          unit: "€", obj: 200000 },
];

export const MONTHS = ["Jan","Fév","Mar","Avr","Mai","Jun","Jul","Aoû","Sep","Oct","Nov","Déc"];
export const MONTHS_F = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];
export const YEARS = [2024, 2025, 2026];

export function fmtNum(v, unit) {
  const n = Number(v) || 0;
  const base = n.toLocaleString("fr-FR");
  return unit === "€" ? `${base} €` : base;
}

export function pct(v, o) {
  if (!o || !v) return 0;
  return Math.min(Math.round((Number(v) / Number(o)) * 100), 150);
}

export function pctColor(p) {
  if (p >= 100) return "#27ae60";
  if (p >= 70) return "#e67e22";
  return "#c0392b";
}

export function initials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function periodLabel(view, year, month, quarter) {
  if (view === "mensuel") return `${MONTHS_F[month]} ${year}`;
  if (view === "trimestriel") return `T${quarter + 1} ${year}`;
  return `Année ${year}`;
}

export function objMult(view) {
  if (view === "mensuel") return 1;
  if (view === "trimestriel") return 3;
  return 12;
}

export const EMPTY_ENTRY = () =>
  Object.fromEntries(KPI_FIELDS.map((f) => [f.key, ""]));

export const DEFAULT_OBJECTIVES = () =>
  Object.fromEntries(KPI_FIELDS.map((f) => [f.key, f.obj]));
